import React from "react";

import communications from "./images/Anuj-img-3.png";

function Contact() {
  return (
    <div className="styles-1">
      <div className="top-gap-1">
        <div className="wrapper">
          <h1>Contact</h1>
          {/* <p>
            Get ready to heighten your communication and anchoring skills with
            upcoming workshops. Anuj is excited to share his expertise through
            interactive, live sessions designed for students and adults.
          </p> */}

          <div className="communications-coach-wrap">
            <div className="communications-coach-1">
              <div className="communications-coach-1-1">
                <div>
                  <br />
                  <p>
                    To contact me you can email at{" "}
                    <span className="style-2">anujgurwara@gmail.com </span>
                  </p>
                  <br /> <br />
                  <h3>Social media</h3>
                  <div
                    className="social-media-wrap social-media-wrap-2"
                    style={{ position: "relative" }}
                  >
                    <ul>
                      <li class="">
                        <a
                          href="https://en.wikipedia.org/wiki/Anuj_Gurwara"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="30"
                            height="30"
                            viewBox="0 0 30 30"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="1"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            class=""
                          >
                            <path
                              d="M15.1013 16.165C14.1263 18.1787 12.79 20.905 12.1275 22.135C11.4862 23.255 10.9525 23.105 10.53 22.165C9.065 18.7025 6.055 12.6337 4.64 9.23124C4.37875 8.60374 4.18125 8.20249 3.995 8.04374C3.80625 7.88749 3.4175 7.79374 2.825 7.75999C2.6075 7.73624 2.5 7.68374 2.5 7.59624V7.12249L2.55375 7.07499C3.5175 7.06999 8.1825 7.07499 8.1825 7.07499L8.235 7.12249V7.57499C8.235 7.69999 8.15625 7.75874 8 7.75874L7.4125 7.78874C6.90875 7.82124 6.65625 7.95999 6.65625 8.24499C6.65625 8.38499 6.71125 8.58874 6.83 8.87124C7.9575 11.6287 11.8512 19.8362 11.8512 19.8362L11.9938 19.885L14.5062 14.87L14.0037 13.7575L12.275 10.3562C12.275 10.3562 11.9438 9.67499 11.8288 9.44749C11.07 7.94374 11.0875 7.86624 10.3212 7.76374C10.105 7.73874 9.995 7.71124 9.995 7.60749V7.11999L10.0575 7.07374H14.53L14.6488 7.11124V7.58124C14.6488 7.69124 14.57 7.73749 14.4125 7.73749L14.0912 7.78624C13.2662 7.84999 13.4025 8.18374 13.95 9.26874L15.5988 12.6587L17.43 9.00624C17.735 8.33999 17.6725 8.17124 17.5462 8.01999C17.4737 7.93249 17.2275 7.78874 16.7 7.76999L16.49 7.74749C16.4349 7.74756 16.3815 7.72857 16.3387 7.69374C16.3167 7.67917 16.2988 7.65927 16.2865 7.63588C16.2743 7.61249 16.2682 7.58638 16.2688 7.55999V7.11374L16.3325 7.06749C17.6325 7.05874 20.5462 7.06749 20.5462 7.06749L20.6087 7.11374V7.56874C20.6087 7.69499 20.5462 7.75374 20.4075 7.75374C19.7337 7.78374 19.5925 7.85249 19.34 8.21124C19.215 8.40374 18.9487 8.82374 18.6675 9.29249L16.2688 13.7462L16.2013 13.8862L19.1112 19.84L19.2887 19.8912L23.87 9.01124C24.0312 8.57124 24.0037 8.25874 23.8037 8.07874C23.5975 7.89874 23.4425 7.79374 22.9087 7.77124L22.4712 7.75374C22.4147 7.75574 22.3591 7.73952 22.3125 7.70749C22.291 7.69408 22.273 7.67576 22.2599 7.65403C22.2469 7.63229 22.2392 7.60777 22.2375 7.58249V7.13124L22.2988 7.08374H27.47L27.5125 7.13124V7.58624C27.5125 7.71124 27.435 7.77374 27.295 7.77374C26.6187 7.80374 26.12 7.96124 25.7912 8.21249C25.4625 8.47874 25.21 8.85499 25.0237 9.32499C25.0237 9.32499 20.81 18.975 19.3687 22.1862C18.8212 23.2362 18.2712 23.1425 17.8025 22.1537C17.2062 20.9325 15.955 18.2087 15.045 16.2025L15.1013 16.165Z"
                              fill="black"
                            />
                          </svg>
                        </a>
                      </li>
                      <li class="">
                        <a
                          href="https://in.linkedin.com/in/anujgurwara"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            class=""
                          >
                            <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"></path>
                            <rect x="2" y="9" width="4" height="12"></rect>
                            <circle cx="4" cy="4" r="2"></circle>
                          </svg>
                        </a>
                      </li>
                      <li class="">
                        <a
                          href="https://www.instagram.com/anujgurwara/"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            class=""
                          >
                            <rect
                              x="2"
                              y="2"
                              width="20"
                              height="20"
                              rx="5"
                              ry="5"
                            ></rect>
                            <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path>
                            <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line>
                          </svg>
                        </a>
                      </li>
                      <li class="">
                        {" "}
                        <a
                          href="https://www.youtube.com/@AnujGurwara1"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <svg
                            width="24"
                            height="20"
                            viewBox="0 0 20 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            stroke="currentColor"
                            stroke-width="1"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            class=""
                          >
                            <path
                              d="M12.792 6.775L9.124 4.663C8.90864 4.53901 8.66446 4.47384 8.41596 4.47402C8.16746 4.47421 7.92337 4.53974 7.70819 4.66404C7.49301 4.78835 7.31431 4.96705 7.19001 5.18223C7.06571 5.39741 7.00018 5.6415 7 5.89V10.112C6.997 10.618 7.267 11.086 7.706 11.336C7.92124 11.4617 8.16596 11.5282 8.41523 11.5285C8.6645 11.5289 8.90941 11.4631 9.125 11.338L12.792 9.226C13.0074 9.10216 13.1864 8.9237 13.3108 8.70863C13.4352 8.49356 13.5008 8.24948 13.5008 8.001C13.5008 7.75252 13.4352 7.50844 13.3108 7.29337C13.1864 7.0783 13.0074 6.89984 12.792 6.776M12.292 8.358L8.626 10.471C8.56261 10.5087 8.49024 10.5286 8.4165 10.5286C8.34276 10.5286 8.27039 10.5087 8.207 10.471C8.14342 10.4348 8.0907 10.3822 8.0543 10.3187C8.0179 10.2552 7.99915 10.1832 8 10.11V5.89C7.99951 5.81717 8.01842 5.74552 8.0548 5.68242C8.09119 5.61933 8.14372 5.56706 8.207 5.531C8.2699 5.49246 8.34223 5.47206 8.416 5.47206C8.48977 5.47206 8.5621 5.49246 8.625 5.531L12.292 7.644C12.3552 7.67972 12.4079 7.73159 12.4445 7.79432C12.4811 7.85704 12.5004 7.92837 12.5004 8.001C12.5004 8.07363 12.4811 8.14496 12.4445 8.20768C12.4079 8.27041 12.3552 8.32228 12.292 8.358ZM17 0H3C2.20459 0.000794215 1.44199 0.31712 0.879557 0.879557C0.31712 1.44199 0.000794215 2.20459 0 3V13C0.000794215 13.7954 0.31712 14.558 0.879557 15.1204C1.44199 15.6829 2.20459 15.9992 3 16H17C17.7954 15.9992 18.558 15.6829 19.1204 15.1204C19.6829 14.558 19.9992 13.7954 20 13V3C19.9992 2.20459 19.6829 1.44199 19.1204 0.879557C18.558 0.31712 17.7954 0.000794215 17 0ZM19 13C18.9992 13.5302 18.7882 14.0384 18.4133 14.4133C18.0384 14.7882 17.5302 14.9992 17 15H3C2.46981 14.9992 1.96156 14.7882 1.58666 14.4133C1.21176 14.0384 1.00079 13.5302 1 13V3C1.00079 2.46981 1.21176 1.96156 1.58666 1.58666C1.96156 1.21176 2.46981 1.00079 3 1H17C17.5302 1.00079 18.0384 1.21176 18.4133 1.58666C18.7882 1.96156 18.9992 2.46981 19 3V13Z"
                              fill="black"
                            />
                          </svg>
                        </a>{" "}
                      </li>
                      {/* <li class="">
                        {" "}
                        <a
                          href="https://www.youtube.com/@speakwithanuj?sub_confirmation=1"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <svg
                            width="16"
                            height="30"
                            viewBox="0 2 13 18"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            stroke="currentColor"
                            stroke-width="1"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            class=""
                          >
                            <path
                              d="M10.5 4C10.5 2.067 8.933 0.5 7 0.5C5.067 0.5 3.5 2.067 3.5 4V9C3.5 10.933 5.067 12.5 7 12.5C8.933 12.5 10.5 10.933 10.5 9V4Z"
                              stroke="black"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M3.5 8.5H5.5M8.5 8.5H10.5M3.5 6.5H5.5M8.5 6.5H10.5M3.5 4.5H5.5M8.5 4.5H10.5"
                              stroke="black"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path d="M7 15V17.5" stroke="black" />
                            <path
                              d="M3.5 17.5H10.5"
                              stroke="black"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M1.40802 11.175C1.8382 12.281 2.58668 13.2346 3.55882 13.9152C4.53095 14.5958 5.68308 14.9729 6.8695 14.9987C8.05593 15.0244 9.22335 14.6978 10.2242 14.0601C11.225 13.4224 12.0142 12.5023 12.492 11.416"
                              stroke="black"
                              stroke-linecap="round"
                            />
                          </svg>
                        </a>{" "}
                      </li>
                      <li class="">
                        <a
                          href="https://x.com/AnujGurwara"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="22"
                            height="22"
                            viewBox="0 0 22 22"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="1"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            class=""
                          >
                            <path
                              d="M12.7792 9.526L19.7409 1.375H18.0909L12.0477 8.45212L7.21874 1.375H1.64999L8.95124 12.078L1.64999 20.625H3.29999L9.68274 13.1505L14.7826 20.625H20.3514L12.7792 9.526ZM10.5201 12.1715L9.78037 11.1059L3.89399 2.62625H6.42812L11.1774 9.46963L11.9171 10.5353L18.0922 19.4315H15.5581L10.5201 12.1715Z"
                              fill="black"
                            />
                          </svg>
                        </a>
                      </li>
                      <li class="">
                        <a
                          href="https://www.imdb.com/name/nm4180576/"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="32"
                            height="32"
                            viewBox="0 2 32 32"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="1"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            class=""
                          >
                            <path
                              d="M22.692 16.6167C22.6938 16.1344 22.8862 15.6724 23.2272 15.3314C23.5683 14.9905 24.0304 14.7982 24.5127 14.7967C24.9949 14.7982 25.457 14.9905 25.7981 15.3314C26.1392 15.6724 26.3316 16.1344 26.3333 16.6167V17.8C26.3318 18.2824 26.1394 18.7445 25.7983 19.0856C25.4572 19.4267 24.9951 19.6191 24.5127 19.6207C24.0305 19.6189 23.5686 19.4266 23.2277 19.0856C22.8867 18.7447 22.6944 18.2828 22.6927 17.8007M22.692 19.6207V12.3387M7.38534 19.6207V12.3387L11.0267 19.6207L14.668 12.3387V19.6207M5.66667 12.3387V19.6207M16.3333 19.616V12.334H17.5173C18.482 12.3371 19.4062 12.7217 20.0884 13.4038C20.7706 14.0858 21.1553 15.01 21.1587 15.9747C21.1555 16.9394 20.7709 17.8638 20.0887 18.546C19.4065 19.2282 18.4821 19.6128 17.5173 19.616H16.3333Z"
                              stroke="black"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M29 25V7.00002C29 6.6464 28.8595 6.30726 28.6095 6.05721C28.3594 5.80716 28.0203 5.66669 27.6667 5.66669H4.33333C3.97971 5.66669 3.64057 5.80716 3.39052 6.05721C3.14048 6.30726 3 6.6464 3 7.00002V25C3 25.3536 3.14048 25.6928 3.39052 25.9428C3.64057 26.1929 3.97971 26.3334 4.33333 26.3334H27.6667C28.0203 26.3334 28.3594 26.1929 28.6095 25.9428C28.8595 25.6928 29 25.3536 29 25Z"
                              stroke="black"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </a>
                      </li> */}
                    </ul>
                  </div>
                </div>
                <div className="communications-box"></div>
                {/*
                <div className="communications-box">
                  <b>YOUR NAME</b>
                  <input type="text" placeholder="" />
                </div>
                <div className="communications-box">
                  <b>EMAIL</b>
                  <input type="text" placeholder="" />
                </div>
                <div className="communications-box">
                  <b>PHONE</b>
                  <input type="text" placeholder="" />
                </div>
                <div className="communications-box">
                  <b>MESSAGE</b>
                  <input type="text" placeholder="" />
                </div>
                <div className="communications-box">
                  <button>SUBMIT</button>
                </div>

                */}
              </div>
            </div>
            <div className="communications-coach-2">
              <img src={communications} alt="communications" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contact;
